var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { getWindowDimension, IdDeviceBreakpointsByWidth, IdMobileHeight } from "./utilResponsive";
var _a = getWindowDimension(), width = _a.width, height = _a.height;
var initialState = { width: width, height: height };
var Responsive = /** @class */ (function (_super) {
    __extends(Responsive, _super);
    function Responsive() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.render = function () {
            var _a = _this.props, children = _a.children, displayIn = _a.displayIn;
            var _b = _this.state, width = _b.width, height = _b.height;
            var dispInArr = displayIn.map(function (val) { return val.toLowerCase(); });
            var shouldRenderChildren = _this.shouldRender(dispInArr, width, height);
            return (React.createElement(React.Fragment, null, shouldRenderChildren ? children : null));
        };
        _this.handleResize = function () {
            var _a = getWindowDimension(), width = _a.width, height = _a.height;
            _this.setState({ width: width, height: height });
        };
        _this.shouldRender = function (display, width, height) {
            if (display.indexOf("laptop") !== -1 &&
                width > height &&
                width >= IdDeviceBreakpointsByWidth.laptop_min) {
                //  always landscape
                return true;
            }
            if (display.indexOf("tablet") !== -1) {
                if (width <= IdDeviceBreakpointsByWidth.tablet_max &&
                    width >= IdDeviceBreakpointsByWidth.tablet_min) {
                    return true;
                }
                //  Cater iPad pro portrait (ONLY)
                if (width === 1024 && height === 1366) {
                    return true;
                }
            }
            // For mobile regardless of orientation
            if (display.indexOf("mobile") !== -1 &&
                width <= IdDeviceBreakpointsByWidth.mobile_max) {
                return true;
            }
            if (display.indexOf("mobileportrait") !== -1 &&
                (width <= IdDeviceBreakpointsByWidth.mobile_max &&
                    height >= IdMobileHeight.mobileLandscape_max)) {
                return true;
            }
            return !!(display.indexOf("mobilelandScape") !== -1 &&
                (width <= IdDeviceBreakpointsByWidth.mobile_max &&
                    height <= IdMobileHeight.mobileLandscape_min));
        };
        return _this;
    }
    Responsive.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.handleResize, false);
    };
    Responsive.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleResize, false);
    };
    return Responsive;
}(React.PureComponent));
export { Responsive };
//# sourceMappingURL=Responsive.js.map